// import { createSelector } from 'reselect';

export const getIsPutting = state => state.getIn(['appointmentAppoint', 'isPutting']);
export const getErrMsg = state => state.getIn(['appointmentAppoint', 'errMsg']);